module.exports = __webpack_public_path__ + "img/Monte_Kope_115.7a6ba961.jpg";